/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UpdateCompanyEmployeeRolesRequest = {
    properties: {
        roles: {
    type: 'array',
    contains: {
    type: 'string',
},
    isRequired: true,
},
        subRole: {
    type: 'number',
    isRequired: true,
},
    },
};